module.exports = __webpack_public_path__ + "img/Lexikan_500px_Putih.d046d513.png";